export default {
  data () {
    return {
      formRules: {
        videoTitle: [{ required: true, message: '请填写视频标题', trigger: 'blur' }],
        sharingStatus: [{ required: true, message: '请设置共享设置', trigger: 'change' }],
        videoIntro: [{ required: true, message: '请填写视频描述', trigger: 'blur' }],
        videoAddress: [{ required: true, message: '请上传视频', trigger: 'change' }],
        youthUuid: [{ required: true, message: '请选择当前培训机构', trigger: 'change' }],
        organUuid: [{ required: true, message: '请选择当前培训协会', trigger: 'change' }]
      }
    }
  }
}
